import { Injectable } from '@angular/core';
import { BaseHttpService } from '../base-http-service.service';
import { AuthInterceptorService } from 'src/app/interceptors/auth.interceptor';

export interface PaymentIntentRequest {
  amount: number;
  bayId: string;
  corporationDetailId: string;
}

export interface PaymentIntentResponse {
  paymentIntentId: string;
  clientSecret: string;
  amount: number;
}

@Injectable({
  providedIn: 'root'
})
export class WalkUpPaymentService extends BaseHttpService {
  constructor(authInterceptor: AuthInterceptorService) {
    super(authInterceptor);
  }

  /**
   * Creates a payment intent for a walk-up booking
   * @param request Payment intent request with amount and other details
   * @returns Observable with the payment intent response
   */
  createWalkUpPaymentIntent(request: PaymentIntentRequest, retry = true): Promise<PaymentIntentResponse> {
    const endpoint = `/api/payment/due-upfront`;
    return this.post<PaymentIntentResponse>(endpoint, request, retry);
  }

  /**
   * Finalizes a walk-up booking after successful payment
   * @param paymentIntentId The Stripe payment intent ID
   * @param bookingDetails The booking details including customer info and duration
   * @returns Observable with the booking confirmation
   */
  finalizeWalkUpBooking(paymentIntentId: string, bookingDetails: any, retry = true): Promise<any> {
    const endpoint = `/api/walk-up/finalize-booking`;
    return this.post<any>(endpoint, {
      paymentIntentId,
      ...bookingDetails
    }, retry);
  }
}
